module.exports = __webpack_public_path__ + "img/newsImg11-19.aa780403.png";